<template>
    <v-container>

        <v-row>
            <v-col cols="12">
                <v-btn color="primary" class="black--text normal-btn" @click="onEditAction" depressed>
                    {{ $t('exercises.create_exercise') }}
                </v-btn>
            </v-col>
            <v-col cols="12">
                <kimsa-data-table
                    :headers="headers"
                    :items="exercises"
                    :loading="loading"
                    searchable
                    @click:edit="onEditAction"
                    @click:hide="onHideAction"
                />
            </v-col>
        </v-row>

        <exercise-creator-desktop-dialog
            ref="exerciseCreator"
            :default-exercise="defaultExercise"
            @hide="defaultExercise = null"
        />

    </v-container>
</template>

<script>

import {db} from "@/utils/Firebase";
import KimsaDataTable from "@/components/common/KimsaDataTable";
import ExerciseCreatorDesktopDialog from "@/components/coach/routines/ExerciseCreatorDesktopDialog";
import {ExerciseIndex} from "@/utils/Algolia";

export default {
    components: {ExerciseCreatorDesktopDialog, KimsaDataTable},
    data(vm) {
        return {
            loading: false,
            exercisesDefaults: [],
            exercises: [],
            headers: [
                {text: '', value: 'img', type: 'img'},
                {text: vm.$t('common.name'), value: 'name'},
                {text: vm.$t('common.categories'), value: 'categories'},
                {text: vm.$t('exercises.types'), value: 'types'},
                {text: vm.$t('exercises.tags'), value: 'tags'},
                {text: vm.$t('equipments.equipments'), value: 'equipments'},
                {text: vm.$t('common.hidden'), value: 'hide', type: 'boolean'},
                {
                    text: '',
                    value: 'actions',
                    buttons: [{text: '', value: 'edit', icon: '$edit'}, {text: '', value: 'hide', type: 'hide'}]
                }
            ],
            defaultExercise: null,
        }
    },
    computed: {
        isCompany(vm = this) {
            return vm.account?.accountType === 'company'
        },
    },
    async mounted() {
        const vm = this
        await vm.loadExercises()
    },
    methods: {
        async loadExercises() {
            const vm = this
            vm.loading = true

            let filterCompany = ''
            if (vm.account.accountType === 'coach_company' || vm.isCompany) {
                filterCompany = `OR companyId: ${vm.account?.coachSubscription?.companyId || vm.currentUser.uid}`
            }
            let filter = `coachId: ${vm.currentUser.uid} ${filterCompany}`

            let exercisesResponse = await ExerciseIndex.search(vm.search, {
                filters: filter,
                hitsPerPage: 10000,
            })

            vm.exercisesDefaults = exercisesResponse.hits

            vm.exercises = exercisesResponse.hits.map(exercise => ({
                id: exercise.objectID,
                objectID: exercise.objectID,
                img: exercise.img || exercise.video?.thumb || vm.imgPlaceholder,
                name: exercise.name,
                categories: vm.getArrayString(exercise.categories),
                types: vm.getArrayString(exercise.types),
                tags: vm.getArrayString(exercise.tags),
                equipments: vm.getArrayString(exercise.equipments),
                hide: exercise.hide || false,
            }))

            vm.loading = false
        },
        getArrayString(array = []) {
            const vm = this
            if (array.length === 0) return vm.$t('common.not_available_short')
            if (array.length <= 2) return array.join(', ')
            return `${array[0]}, ${array[1]} (+${array.length - 2})`
        },
        async onHideAction(exerciseId) {
            const vm = this
            let exercise = vm.exercises.find(exercise => exercise.id === exerciseId)
            let hide = !exercise?.hide
            await db.collection('exercises').doc(exerciseId).update({hide})
            let exerciseIndex = vm.exercises.findIndex(exercise => exercise.id === exerciseId)
            vm.exercises[exerciseIndex].hide = hide
            vm.toast(hide ? vm.$t('common.hidden_exercise') : vm.$t('common.visible_exercise'))
        },
        onEditAction(exerciseId) {
            const vm = this
            if(exerciseId) vm.defaultExercise = vm.exercisesDefaults.find(exercise => exercise.id === exerciseId)
            // console.log('defaultExercise',vm.defaultExercise)
            vm.$refs.exerciseCreator.show()
        }
    }
}
</script>

<style scoped>

</style>
